import { useState, useMemo } from "react";
import Confirmation from "../common/modal/confirmation";
import useScrollLock from "./useScrollLock";

export const defaultModalConfig = {
  isOpen: false,
  type: "",
  title: "",
  message: [],
  handleConfirm: null,
  handleCancel: null,
};

export const getModalContent = (modalConfig) => {
  const modalProps = {
    ...modalConfig,
    title: modalConfig.title,
    message: modalConfig.message,
    handleConfirm: modalConfig.handleConfirm,
    handleCancel: modalConfig.handleCancel,
  };

  switch (modalConfig.type) {
    case "confirmation":
      return (
        <div style={{ display: modalConfig.isOpen ? "block" : "none" }}>
          <Confirmation {...modalProps} />
        </div>
      );
    default:
      return null;
  }
};

export const useModal = () => {
  const [modalConfig, setModalConfig] = useState({ ...defaultModalConfig });

  const modal = useMemo(() => getModalContent(modalConfig), [modalConfig]);
  useScrollLock(modalConfig.isOpen);

  const openModal = (options) => {
    setModalConfig({
      isOpen: true,
      ...options,
    });
  };

  const closeModal = () => {
    setModalConfig((prev) => ({ ...prev, isOpen: false }));
  };

  return { modal, openModal, closeModal };
};
